module.exports = __webpack_public_path__ + "static/media/place-1.a838dbf3.jpg";